import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export const WriteBackToGreenhouseMergeAuthMethod = z.object({
  type: z.literal('merge'),
  dataSetId: z.string().optional(),
});

export const WriteBackToGreenhouseApiAuthMethod = z.object({
  type: z.literal('api'),
  apiKeySecretReference: SecretReference.optional(),
});

export const WriteBackToGreenhouseConnectionMethod = z.object({
  type: z.literal('connection'),
});

export type WriteBackToGreenhouseConnectionMethod = z.infer<
  typeof WriteBackToGreenhouseConnectionMethod
>;

export type WriteBackToGreenhouseApiAuthMethod = z.infer<
  typeof WriteBackToGreenhouseApiAuthMethod
>;

export type WriteBackToGreenhouseMergeAuthMethod = z.infer<
  typeof WriteBackToGreenhouseMergeAuthMethod
>;

export const WriteBackToGreenhouseAuthMethod = z.union([
  WriteBackToGreenhouseMergeAuthMethod,
  WriteBackToGreenhouseApiAuthMethod,
  WriteBackToGreenhouseConnectionMethod,
]);

export type WriteBackToGreenhouseAuthMethod = z.infer<
  typeof WriteBackToGreenhouseAuthMethod
>;

export const WriteBackToGreenhouseCustomFieldPlaceToWrite = z.object({
  type: z.literal('customField'),
  customFieldKey: z.string(),
  onBehalfOfUserId: z.string(),
});

export type WriteBackToGreenhouseCustomFieldPlaceToWrite = z.infer<
  typeof WriteBackToGreenhouseCustomFieldPlaceToWrite
>;

export const WriteBackToGreenhousePlaceToWrite =
  WriteBackToGreenhouseCustomFieldPlaceToWrite;

export type WriteBackToGreenhousePlaceToWrite = z.infer<
  typeof WriteBackToGreenhousePlaceToWrite
>;

export const WriteBackToGreenhouseStrategy = z.object({
  type: z.literal('greenhouse'),
  authMethod: WriteBackToGreenhouseAuthMethod.optional(),
  placesToWrite: z.array(WriteBackToGreenhousePlaceToWrite).optional(),
});

export type WriteBackToGreenhouseStrategy = z.infer<
  typeof WriteBackToGreenhouseStrategy
>;
